import { render } from "./App.vue?vue&type=template&id=4a229ff0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4a229ff0&lang=css"
script.render = render

export default script